import { render, staticRenderFns } from "./OCambioCarType.vue?vue&type=template&id=50149e26&"
import script from "./OCambioCarType.vue?vue&type=script&lang=js&"
export * from "./OCambioCarType.vue?vue&type=script&lang=js&"
import style0 from "./OCambioCarType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports